export default [{
  mainButton: {
    name: 'departments-settings',
    label: 'Departments',
    goTo: '/settings/departments/',
    tooltip: 'Viewing and changing department parameters'
  },
  fastButtons: [{
    name: 'timetableTemplateAdd',
    label: 'add department',
    goTo: '/settings/departments/?modal=DepSettings~-1'
  }],
  filterModalName: 'settingsShops'
}, {
  mainButton: {
    name: 'positions',
    label: 'Positions<br>staff',
    goTo: '/settings/positions/',
    tooltip: 'Viewing and changing staff positions'
  },
  fastButtons: [{
    name: 'positionAdd',
    label: 'add position',
    goTo: '/settings/positions/?modal=Position~-1'
  }],
  filterModalName: 'settingsPositions'
}, {
  mainButton: {
    name: 'accessGroups',
    label: 'Access<br>groups',
    goTo: '/settings/access-groups/',
    tooltip: 'Viewing and changing access groups'
  },
  fastButtons: [{
    name: 'accessGroupAdd',
    label: 'add access group',
    goTo: '/settings/access-groups/?modal=AccessGroup~-1'
  }, {
    name: 'blockWorkingDaysUpdate',
    label: 'restriction on editing shifts',
    goTo: '/settings/access-groups/?modal=blockWorkingDays'
  }],
  filterModalName: 'settingsAccessGroups'
}, {
  mainButton: {
    name: 'businessDrivers',
    label: 'Business<br>drivers',
    goTo: '/settings/business-drivers/',
    tooltip: 'Viewing and changing business drivers'
  },
  fastButtons: [{
    name: 'businessDriverAdd',
    label: 'add business driver',
    goTo: '/settings/business-drivers/?modal=BusinessDriver~-1'
  }],
  filterModalName: 'settingsBusinessDrivers'
}, {
  mainButton: {
    name: 'operations',
    label: 'Operations',
    goTo: '/settings/operations/',
    tooltip: 'Viewing and changing operations'
  },
  fastButtons: [{
    name: 'operationAdd',
    label: 'add operation',
    goTo: '/settings/operations/?modal=Operation~-1'
  }],
  filterModalName: 'settingsOperations'
}, {
  mainButton: {
    name: 'workTypes',
    label: 'Work types',
    goTo: '/settings/work-types/',
    tooltip: 'Viewing and changing work types'
  },
  fastButtons: [{
    name: 'workTypeAdd',
    label: 'add work type',
    goTo: '/settings/work-types/?modal=WorkType~-1'
  }],
  filterModalName: 'settingsWorkTypes'
}, {
  mainButton: {
    name: 'loadTemplates',
    label: 'Load<br>templates',
    goTo: '/settings/load-templates/',
    tooltip: 'Viewing and changing load templates'
  },
  fastButtons: [{
    name: 'loadTemplateAdd',
    label: 'add load template',
    goTo: '/settings/load-templates/?modal=LoadTemplate~-1'
  }],
  filterModalName: 'settingsLoadTemplates'
}, {
  mainButton: {
    name: 'timetable-templates',
    label: 'Timetable<br>templates',
    goTo: '/settings/timetable-templates/',
    tooltip: 'Viewing and changing timetable templates'
  },
  fastButtons: [{
    name: 'timetableTemplateAdd',
    label: 'add timetable template',
    goTo: '/settings/timetable-templates/?modal=TimetableTemplate~-1'
  }],
  filterModalName: 'settingsTimetableTemplates'
}, {
  mainButton: {
    name: 'tickpoints',
    label: 'Tickpoints',
    goTo: '/settings/tickpoints/',
    tooltip: 'Viewing and changing tickpoints'
  },
  fastButtons: [{
    name: 'tickpointAdd',
    label: 'add tickpoint',
    goTo: '/settings/tickpoints/?modal=Tickpoint~-1'
  }],
  filterModalName: 'settingsTickpoints'
}];